<template>
  <section class="form-textarea">
    <FormInput
      v-model="computedValue"
      v-on="$listeners"
      type="textarea"
      ref="formInput"
      @keyup="onKeyUp"
      @input="onInput"
      v-bind="$props"
    >
      <template #error="validationProps">
        <slot name="error" v-bind="validationProps" />
      </template>
    </FormInput>
  </section>
</template>

<script>
import FormInput from '/@/modules/core/form/components/FormInput.vue';
import { FormComputedValueMixin } from '/@/modules/core/form/mixins/FormComputedValueMixin';
import { FormInputMixin } from '/@/modules/core/form/mixins/FormInputMixin';
import { KeyCode } from '/@/modules/core/ui/ui.constants';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FormTextarea',
  emits: ['keyup'],
  slotsDefinition: {
    error: { validationProps: Object }
  },
  mixins: [FormComputedValueMixin, FormInputMixin],
  components: {
    FormInput
  },
  props: {
    maxLength: { type: [Number, String], default: null },
    rows: { type: [Number, String], default: null },
    autoHeight: { type: Boolean, default: false },
    hasShiftEnter: { type: Boolean, default: false }
  },
  methods: {
    onKeyUp(event) {
      if (this.hasShiftEnter && event.keyCode === KeyCode.ENTER.value && !event.shiftKey) {
        return;
      }

      this.$emit('keyup', event);
      this.resize();
    },
    onInput(input) {
      this.$nextTick(() => {
        this.computedValue = input.trim().length === 0 ? '' : input;
      });
    },
    resize() {
      if (!this.autoHeight) {
        return;
      }

      const textarea = this.$refs?.formInput.$refs.refInput.$el.querySelector('textarea');
      setTimeout(() => {
        textarea.style.overflowY = 'hidden';
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
      }, 0);
    },
    focus() {
      this.$refs.formInput?.focus?.();
    }
  },
  mounted() {
    this.resize();
  }
};
</script>

<style scoped>
:deep(textarea) {
  min-height: var(--ce-43px);
}
</style>
